import React from 'react';
import './LegalPage.css';

const RefundPage = () => (
  <div className="legal-page">
    <h1>Refund Policy</h1>
    <p className="legal-updated">Last updated: 17 September 2026</p>

    <h2>A one-time, non-refundable service</h2>
    <p>
      Thank you for choosing Irish Visa Tracker. Premium is a one-time service
      purchase, not a recurring subscription. We do not offer refunds for
      this purchase or a money-back guarantee, subject to any rights required
      by applicable law.
    </p>

    <h2>Why the fee is non-refundable</h2>
    <p>
      Once your payment is verified, we begin setting up monitoring for your
      registered visa references and make the premium planning tools available.
      The fee supports this setup, access to the tools, ongoing publication
      checks and notification processing. It is not a fee for a particular
      visa outcome or a charge based on how often you use the service.
    </p>
    <p>
      Because this work and access begin with activation, we do not offer
      change-of-mind refunds, refunds for unused access, or prorated refunds.
      A visa approval, refusal, withdrawal or change in your travel plans does
      not by itself qualify for a refund under this policy.
    </p>

    <h2>Before you purchase</h2>
    <p>
      We understand that visa plans can change. Please review what premium
      includes and check your email address and visa reference numbers before
      paying. We monitor official publications; we do not influence immigration
      decisions or guarantee a decision date or exact notification time.
      If you are unsure whether the service meets your needs, please contact us
      before purchasing.
    </p>

    <h2>Billing errors and service support</h2>
    <p>
      If you notice a duplicate charge, cannot access premium after payment,
      or experience a service problem, email{' '}
      <a href="mailto:visahelp@irelandvisatracker.in">visahelp@irelandvisatracker.in</a>{' '}
      from your purchase email address with your transaction ID and a brief
      description. We will investigate and work with you to resolve the issue.
      Please do not send payment-card details or passwords.
    </p>

    <h2>Your rights</h2>
    <p>
      This policy does not limit rights or remedies that cannot be excluded
      under applicable consumer-protection law. Rights arising from the terms
      presented at the time of an earlier purchase are not affected by this update.
    </p>
  </div>
);

export default RefundPage;
